/* Bean Bros FAQ page (sections/bb-faq.liquid): search, topic filter, delivery toggle.
   Without this script every question is still readable as <details>; only filtering is lost. */
(function () {
  function init(root) {
    if (root.dataset.faqInit) return;
    root.dataset.faqInit = '1';
    root.classList.add('bb-faq--js');

    var search = root.querySelector('[data-faq-search]');
    var results = root.querySelector('[data-faq-results]');
    var clearBtn = root.querySelector('[data-faq-clear]');
    var empty = root.querySelector('[data-faq-empty]');
    var delivery = root.querySelector('[data-faq-delivery]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));
    var topicBtns = Array.prototype.slice.call(root.querySelectorAll('[data-topic-btn]'));
    var deliveryTopic = root.dataset.deliveryTopic || 'shipping';
    var deliveryTerms = ['deliver', 'shipping', 'ship', 'express', 'standard', 'carrier', 'fedex', 'postnord', 'days',
      'lever', 'fragt', 'versand', 'liefer', 'spedizion', 'consegna', 'giorni', 'dage', 'tage'];
    var state = { topic: '', q: '' };

    function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
    function label(tpl, n, q) { return (tpl || '').replace('[n]', n).replace('[q]', q); }

    groups.forEach(function (g) {
      g.querySelectorAll('[data-faq-q]').forEach(function (d) { d._text = norm(d.textContent); });
    });
    var deliveryText = delivery ? norm(delivery.textContent) : '';

    function apply() {
      var q = norm(state.q);
      var shown = 0;
      groups.forEach(function (g) {
        var inTopic = !state.topic || g.dataset.faqGroup === state.topic;
        var groupShown = 0, firstMatch = null;
        g.querySelectorAll('[data-faq-q]').forEach(function (d) {
          var hit = inTopic && (!q || d._text.indexOf(q) !== -1);
          d.hidden = !hit;
          if (hit) { groupShown++; if (!firstMatch) firstMatch = d; }
        });
        g.hidden = groupShown === 0;
        if (q && firstMatch) firstMatch.open = true;
        shown += groupShown;
      });

      if (delivery) {
        var topicOk = !state.topic || state.topic === deliveryTopic;
        var qOk = !q || deliveryText.indexOf(q) !== -1 || (q.length >= 3 && deliveryTerms.some(function (t) { return t.indexOf(q) === 0 || q.indexOf(t) === 0; }));
        delivery.hidden = !(topicOk && qOk);
      }

      var deliveryShown = delivery && !delivery.hidden;
      if (empty) empty.hidden = shown > 0 || deliveryShown;
      if (results) {
        results.textContent = q
          ? label(shown === 1 ? root.dataset.tAnswer : root.dataset.tAnswers, shown, state.q.trim())
          : label(shown === 1 ? root.dataset.tQuestion : root.dataset.tQuestions, shown, '');
      }
      if (clearBtn) clearBtn.hidden = !(q || state.topic);
      topicBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.topicBtn === state.topic ? 'true' : 'false'); });
    }

    topicBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var t = b.dataset.topicBtn;
        // Clicking the active topic card again shows all topics
        state.topic = (t && t === state.topic) ? '' : t;
        apply();
      });
    });
    if (search) {
      search.addEventListener('input', function () { state.q = search.value; apply(); });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        state.topic = ''; state.q = '';
        if (search) search.value = '';
        apply();
      });
    }
    // Links to the delivery table: make sure it's visible before jumping
    root.querySelectorAll('a[href="#delivery"]').forEach(function (a) {
      a.addEventListener('click', function () {
        if (delivery && delivery.hidden) {
          state.topic = ''; state.q = '';
          if (search) search.value = '';
          apply();
        }
      });
    });
    root.querySelectorAll('[data-mode-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!delivery) return;
        delivery.dataset.mode = b.dataset.modeBtn;
        root.querySelectorAll('[data-mode-btn]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
      });
    });

    apply();
  }

  function boot() { document.querySelectorAll('[data-bb-faq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
